import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import brand from "@/config/brand";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-surface-50 text-ink-900">
      <Header />
      <main data-testid="terms-page">
        <section className="border-b border-surface-200 bg-white">
          <div className="mx-auto max-w-3xl px-6 pt-10 pb-8 lg:px-8 lg:pt-14 lg:pb-10">
            <p className="text-xs font-medium uppercase tracking-widest text-intel-800">Terms</p>
            <h1 className="mt-2 text-3xl font-bold tracking-tight text-ink-900 sm:text-4xl">
              شروط الاستخدام
            </h1>
            <p className="mt-3 text-sm text-ink-500">
              تاريخ السريان: <span dir="ltr" className="font-mono">{brand.legal.termsEffectiveDate}</span>
            </p>
          </div>
        </section>
        <section className="mx-auto max-w-3xl px-6 py-10 lg:px-8 lg:py-14">
          <div className="space-y-6 text-[15px] leading-relaxed text-ink-800">
            <p>
              يُنظِّم هذا المستند علاقة المستخدم بمنصة {brand.name}. باستخدامك للمنصة، أنت توافق على البنود التالية.
            </p>

            <h2 className="text-lg font-semibold text-ink-900">طبيعة الخدمة</h2>
            <p>
              {brand.name} منصّة استخبارات اقتصادية تُقدِّم تحليلات وفرصاً مصنَّفة بمنهجية شفَّافة.
              المحتوى المنشور <span className="font-semibold">لأغراض معلوماتية فقط</span> ولا يُشكِّل نصيحة
              استثمارية أو مالية أو قانونية. قرارات الاستثمار تبقى مسؤولية المستخدم.
            </p>

            <h2 className="text-lg font-semibold text-ink-900">الاستخدام المقبول</h2>
            <p>
              يُمنع استخدام المنصة لأي غرض غير قانوني، أو محاولة اختراق أنظمتها، أو استخراج بياناتها
              بالجملة عبر أدوات آلية دون إذن كتابي. يحق لنا تعليق أي حساب يُخالف هذه الشروط.
            </p>

            <h2 className="text-lg font-semibold text-ink-900">الملكية الفكرية</h2>
            <p>
              جميع المحتويات والتحليلات ونظام النقاط والتصنيفات المنشورة على {brand.name} مملوكة للمنصّة.
              يُسمح بمشاركة روابط الفرص ذات النطاق العام؛ ولا يُسمح بإعادة نشر المحتوى بالكامل
              دون إسناد واضح ودون إذن كتابي مسبق للاستخدامات التجارية.
            </p>

            <h2 className="text-lg font-semibold text-ink-900">حدود المسؤولية</h2>
            <p>
              نبذل قصارى جهدنا لتوثيق المصادر والتحقُّق من البيانات، لكن لا نضمن دقّتها 100% ولا اكتمالها.
              لا تتحمَّل {brand.name} مسؤولية أي خسائر مباشرة أو غير مباشرة تنشأ عن قرارات مبنيَّة
              على المحتوى المنشور.
            </p>

            <h2 className="text-lg font-semibold text-ink-900">التحديثات</h2>
            <p>
              قد نُحدِّث هذه الشروط من حين لآخر. الاستخدام المستمر للمنصة بعد التحديث يُعدّ موافقة
              على النسخة السارية.
            </p>

            <h2 className="text-lg font-semibold text-ink-900">التواصل</h2>
            <p>
              لأي استفسار حول هذه الشروط، راسلنا على{" "}
              <a href={`mailto:${brand.contact.email}`} className="font-medium text-intel-800 underline">
                {brand.contact.email}
              </a>.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
